/* AllFun Games: the phone menu (the BrightSyntax full-screen menu) and the header border on scroll. */
(function () {
  'use strict';
  var toggle = document.querySelector('.nav-toggle');
  var menu = document.getElementById('site-menu');
  function setMenu(open) {
    if (!toggle || !menu) return;
    document.body.classList.toggle('menu-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
  }
  if (toggle && menu) {
    toggle.addEventListener('click', function () { setMenu(toggle.getAttribute('aria-expanded') !== 'true'); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
    window.addEventListener('resize', function () { if (window.innerWidth > 760) setMenu(false); });
  }
  var nav = document.querySelector('.nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 8); };
    // First read in the next frame, with the page's other start-up reads (speed, 29.10: reading the scroll position here
    // made the browser lay out the whole page once more; the class still shows in the same frame as before).
    requestAnimationFrame(onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
